import { render } from "./Merchant.vue?vue&type=template&id=1f0c872c&scoped=true"
import script from "./Merchant.vue?vue&type=script&lang=js"
export * from "./Merchant.vue?vue&type=script&lang=js"

import "./Merchant.vue?vue&type=style&index=0&id=1f0c872c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0c872c"]])

export default __exports__